var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDairyFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3151 0.999756V3.26613L13.2426 5.83856V12.4313L15.4065 14.5953C15.6315 14.8202 15.6315 15.1849 15.4065 15.4099C15.1816 15.6348 14.8169 15.6348 14.5919 15.4099L13.2426 14.0605V14.6516H2.22932V5.83856L3.42491 4.24284L1.59254 2.41047C1.36759 2.18553 1.36759 1.82082 1.59254 1.59588C1.81748 1.37094 2.18218 1.37094 2.40713 1.59588L4.12273 3.31148L4.15671 3.26613V0.999756H11.3151ZM4.02813 4.84606L3.49548 5.55697H4.73903L4.02813 4.84606ZM6.36822 5.55697L4.72596 3.91471L4.79018 3.82898H10.049L8.75431 5.55697H6.36822ZM5.58348 6.40141H3.07377V13.8072H8.54332V9.36125L5.58348 6.40141ZM8.54332 7.73207L7.21266 6.40141H8.54332V7.73207ZM9.38776 10.2057V13.8072H12.3981V13.2161L9.38776 10.2057ZM12.3981 11.5869L9.38776 8.57651V6.11982L10.8929 4.11089L12.3981 6.11979V11.5869ZM10.4707 2.98451V1.8442H5.00115V2.98451H10.4707Z",
    fill: "#2D3958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairyFree);
export default __webpack_public_path__ + "static/media/dairy-free.68a94c6847aca58d9c8405e34965e43d.svg";
export { ForwardRef as ReactComponent };